export default {
  melik: {
    img: '/speakers/melik.jpeg',
    name: 'Melik Karapetyan',
    position: 'Sr Engineering Director at Krisp',
  },
  vahram: {
    img: '/speakers/vahram.jpeg',
    name: 'Dr. Vahram Martirosyan',
    position: 'Experienced System Engineer and Lecturer',
  },
  erik: {
    img: '/speakers/erik.png',
    name: 'Erik Davtyan',
    position: 'Senior Backend Engineer at Not Diamond',
  },
  anastasia: {
    img: '/speakers/anastasia.jpg',
    name: 'Anastasia Egorova',
    position: 'Frontend Engineer, Course author and Youtuber',
  },
  armen: {
    img: '/speakers/armen.jpg',
    name: 'Armen Vardanyan',
    position: 'Google Developer Expert for Angular, Front-end Team Lead at VOLO',
  },
  david: {
    img: '/speakers/david.jpeg',
    name: 'David Mkrtchyan',
    position: 'Site Reliability Engineering Lead at Ameriabank',
  },
  rouben: {
    img: '/speakers/rouben.png',
    name: 'Rouben Meschian',
    position: 'Software Engineer | Educator',
  },
  pavel: {
    img: '/speakers/pavel.jpg',
    name: 'Pavel Vostrikov',
    position: 'Web Engineer at Kaspersky and creator of MoscowJS',
  },
  edgar: {
    img: '/speakers/edgar.jpg',
    name: 'Edgar Marukyan',
    position: 'CTO at Bioneex',
  },
  edgar1: {
    img: '/speakers/edgar.jpg',
    name: 'Moderator: Edgar Marukyan',
    position: 'CTO at Bioneex',
  },
  aram: {
    img: '/speakers/aram.jpg',
    name: 'Aram Mkhitaryan',
    position: 'Head of Yandex Armenia & Georgia',
  },
  vladimir: {
    img: '/speakers/vladimir.jpg',
    name: 'Vladimir Khoetsyan',
    position: 'CTO at Wirestock',
  },
};
